<template>
    <div class="initial-generate-module-index">
        <DashboardLayoutComponent
            @on-set-current-sidebar="onSetCurrentSidebar($event)"
        >
            <div class="bottom-9">
                <br>
                <div v-if="route.params.attribute == 'list'">
                    <TableView />
                </div>
                <div v-else class="initial-landing">
                    <div class="initial-landing__wrapper py-5 flex justify-between">
                        <div>
                            <PresentationChartLineIcon class="initial-landing__icon" />
                        </div>
                        <ButtonComponent
                            type="primary-btn"
                            label="Save"
                            class="w-32 text-center item-center justify-center mr-3"
                            @click="onShowModal()"
                        />
                    </div>
                    <FormView class="overflow-x-auto whitespace-nowrap" />
                </div>
            </div>
        </DashboardLayoutComponent>
    </div>

    <SlotModalComponent
        v-model="showModal"
        container-class="notice-modal"
        :scrollable="false"
        :is-semi-transparent="true"
    >
        <template v-slot:body>
            <div class="body-wrapper">
                <input
                    v-model="inputTemplate"
                    type="text"
                    class="input-class"
                    placeholder="Template Name"
                >
                <input
                    v-model="inputDescription"
                    type="text"
                    class="mt-3 input-class"
                    placeholder="Description"
                >
            </div>
        </template>
        <template v-slot:footer="{ onCancel }">
            <div class="footer-wrapper flex">
                <ButtonComponent
                    type="button"
                    label="Return"
                    class="buttonFilter"
                    style="width: 49% !important; display: inline-block !important;"
                    @click="onCancel"
                />
                <ButtonComponent
                    label="Save"
                    class="ml-2 justify-center"
                    style="width: 49% !important;height:41px;"
                    :loading="onSaveLoading"
                    @click.once="onSave()"
                />
            </div>
        </template>
    </SlotModalComponent>
    <DialogBoxComponent
        :status="isOpenDialog"
        :message="dialogMessage"
        :reload="false"
        :type="dialogBoxType"
        @close-modal="closeModal()"
    />
</template>

<script>
import DashboardLayoutComponent from "@Layouts/dashboard/";
import FormView from "@GenerateModule/pages/form.vue";
import TableView from "@GenerateModule/pages/table.vue";
import { PresentationChartLineIcon } from "@heroicons/vue/outline";
import { ref, computed, watch } from "vue";
import { SlotModalComponent } from "@CommonComponents";
import useReport from "@Functions/useReport.js";
import useSections from "@Functions/useSections.js";
import useMenuNav from "@Functions/useMenuNav.js";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from "vuex"
import { useReportStore } from "@Store"
export default {
    name: "GenerateModule",
    components: {
        DashboardLayoutComponent,
        PresentationChartLineIcon,
        TableView,
        FormView,
        SlotModalComponent
    },
    setup() {
        const store = useStore()
        const showModal = ref(false);
        const formRes = ref();
        const inputTemplate = ref('');
        const inputDescription = ref('');
        const { saveReport, updateReport } = useReport();
        const isLoading = ref(false);
        const route = useRoute()
        const router = useRouter()
        const isOpenDialog = ref(false);
        const dialogMessage = ref('');
        const dialogBoxType = ref("normal")
        const reportStore = useReportStore();
        const onSaveLoading = ref(false)

        const info = computed(() => {
            return store.getters["Reports/getInfo"]
        })
        watch(() => info.value, () => {
            inputTemplate.value = info.value.template_name
            inputDescription.value = info.value.description
        })

        const {
            onNavChanged,
            onSetCurrentSidebar,
        } = useSections();
        const {
            menuNavRedirect,
            menuNav,
            onMenuNavTypeChange
        } = useMenuNav();

        const closeModal = (item) => {
            isOpenDialog.value = item
        }

        const formValidate = (type, obj) => {
            let res = {
                validate: true
            }

            switch (type) {
            case 'name':
                if (!obj.inputTemplate.value) {
                    res.validate = false
                    res.message = "Please define template name."
                }
                break;
            case 'filter':
                reportStore.form.filter.some(item => {
                    if ((item.where === 'Field' || _.isEmpty(item.value)) && ((item.condition !== 'exists' && item.condition !== 'doesnotexists'))) {
                        res.validate = false
                        res.message = "Please provide the required information for the 'Additional Filters'."
                    }
                });
                break;
            case 'dimension':
                if (reportStore.form.dimension.length < 1) {
                    res.validate = false
                    res.message = "Please define dimensions."
                }
                break;
            case 'metric':
                if (![ 'quarter', 'cumulative' ].some(val => reportStore.form.metric.column.includes(val))) {
                    res.validate = false
                    res.message = "Please define quarter or cumulative in metrics."
                }
                break;
            }
            return res
        }

        const onSave = () => {
            let formValidated
            onSaveLoading.value = true
            for (let item of [ 'name', 'dimension', 'metric', 'filter' ]) {
                formValidated = formValidate(item, { inputTemplate })
                if ( !formValidated.validate ) {
                    onSaveLoading.value = false
                    isOpenDialog.value = true;
                    dialogMessage.value = formValidated.message
                    showModal.value = false;
                    dialogBoxType.value = formValidated.validate ? 'success' : 'fatal'
                    return false
                }
            }

            let path = '/template/report/list/';

            const queryConfig = {
                config: {
                    dimensionValue: reportStore.form.dimension,
                    dimensionOption: reportStore.form.dimensionOption,
                    metricValue: {
                        column: reportStore.form.metric?.column,
                        granularity: reportStore.form.metric?.granularity
                    },
                    filterValue: reportStore.form.filter
                },
            };
            const queries = [ queryConfig ];

            const reportParams = {
                name: inputTemplate.value,
                desc: inputDescription.value,
                query: queries
            };

            if (route.params.attribute === 'update') {
                updateReport(reportParams, route.params.id).then(() => {
                    onSaveLoading.value = false
                    router.push({
                        path,
                    })
                    showModal.value = false;
                })
            } else {
                saveReport(reportParams).then(() => {
                    onSaveLoading.value = false
                    router.push({
                        path,
                    })
                    showModal.value = false;
                });
            }
        };

        const onShowModal = () => {
            showModal.value = true;
        }

        return {
            isLoading,
            inputTemplate,
            inputDescription,
            onSave,
            route,
            showModal,
            onShowModal,
            onNavChanged,
            onSetCurrentSidebar,
            menuNavRedirect,
            menuNav,
            onMenuNavTypeChange,
            isOpenDialog,
            dialogMessage,
            info,
            closeModal,
            dialogBoxType,
            formRes,
            onSaveLoading
        };
    },
};
</script>

<style lang="scss" scoped>
.initial-generate-module-index {
    .initial-landing {
        @apply border border-gray-200 rounded-lg shadow-sm divide-gray-200 bg-white w-full;
        align-content: start;
        .initial-landing {
            &__wrapper {
                @apply flex items-center p-3 border-b;
            }
            &__icon {
                @apply h-6 w-6 ml-4 text-gray-400;
            }
            &__list {
                @apply p-3;
                &.empty-state-component {
                    @apply md:col-span-2;
                }
            }
        }
    }
    .spinner-component {
        @apply flex items-center justify-center;
        min-height: 67vh;
    }
}

.buttonFilter{
    @apply justify-center mr-2 text-green-700 hover:text-white border border-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-800;
}
.input-class{
    @apply bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500;
}
</style>
